import { 
  ORDERS_COUNTS_REQUEST,
  ORDERS_COUNTS_SUCCESS,
  ORDERS_COUNTS_FAIL,
} from '../constant'
import axios from 'axios'
import { api_url, authHeader } from '../api/ApiUtills'

export const OrdercountsAction=() => async (dispatch) =>{
  try{
    dispatch({type:ORDERS_COUNTS_REQUEST})
      const {data} = await axios.get(`${api_url}/orders/counts`,
        authHeader()
    )
    dispatch({
      type:ORDERS_COUNTS_SUCCESS,
      payload:data
    })
  }catch(error){
    dispatch({
      type:ORDERS_COUNTS_FAIL,
      payload: error.response && error.response.data.message
      ?error.response.data.message
      :error.message,
    })
  }
}